<template>
  <div style="clear: both">
      <div class="Navcontainer hidden-sm-and-down" v-if="show">
        <div class="Nav">
          <div class="headleft">
            <router-link to="/">
              <h1> <img class="logo1" src="../../static/liuyanlogo.png" alt=""/></h1>
              <h1 class="logo2"><img src="../../static/logo2.png" alt=""></h1>
            </router-link>
          </div>
          <div class="headrig">
            <ul class="nav_list">
                  <li  v-for="(item, index) in navlist" :key="index" :class="{'shop':item.route === 'Shopping'}">
                     <span class="cartCount" :class="{'carthide':item.route === 'Shopping'}"  v-if="carCount !==0">
                        <img src="../assets/shopicon.png" alt="">
                        <i  style="color: #fff">{{ carCount }}</i>
                      </span>
                      <el-dropdown :disabled="!item.list.length" class="nav_dropdown" @visible-change="changeValue1($event,item.list.length)">
                        <span>
                            <router-link :to=" item.classify_id == null ? {  name:item.route } : {  name:item.route, query: {id: item.classify_id} } ">
                             <u>{</u>{{ item.name }}<u>}</u> 
                          </router-link>
                        </span>
                        <el-dropdown-menu>
                          <div class="menubox">
                            <div class="menu_left">
                              <div style="float:right; min-width:45%;">
                                <h6>{{ item.name }}</h6>
                                <div style="display:flex;">
                                  <ul v-for="(i,num) in spArray(5,item.list)" :key="num">
                                    <li v-for="(items, index) in i" :key="index">
                                      <router-link :to=" items.route  ? {  name:items.route } : {  name:'Product', query: {id: items.id} } ">{{ items.name }}</router-link>
                                    </li>
                                  </ul>                                    
                                </div>
                              </div>
                            </div>
                              <div style="width:1px;min-height:300px;background:rgba(0, 40, 46, 0.2);display: inline-block;float:left"></div>
                              <div  class="menu_rig">
                                <div v-if="item.route=='Brand'">
                                  <video :src="imgsrc + item.video" style="width:50%; border-radius: 10px;" controls></video>
                                  <p class="product_name">媒体报道</p>
                                </div>
                                <div v-else>
                                  <router-link :to="{  name:'Product', query: {id: item.product_id} }" style="display:inline-block;">
                                    <img v-if="item.list.length" :src="imgsrc + item.nav_product_img" alt="">
                                    <p class="product_name">{{ item.product_name }}</p>
                                  </router-link>
                                </div>
                                  <p>明星＆节目同款好物</p>
                              </div>
                          </div>
                        </el-dropdown-menu>
                      </el-dropdown>
                  </li>
           
            </ul>
          </div>
        </div>
    </div>
    <!-- 手机端显示 -->
    <div v-if="ismodal" class="v-modal " tabindex="0" style="z-index: 124;"></div>
    <div class="hidden-md-and-up phone">
     <div class="tabber">
        <div v-if="Searchdrawer" class="Search">
          <el-input placeholder="请输入内容" v-model="input4" class="input-with-select">
            <el-button style="border-radius:unset;" slot="append" icon="el-icon-search"  @click="validateCounts"></el-button>
            <el-button style="border-radius:unset; font-size:0.24rem;color: #00383F" slot="append" @click="Cancle">取消</el-button>
          </el-input>
        </div>
       <ul>
           <li v-if="this.block">
              <a href="#" style="padding-top:0.34rem">
                <img  @click="drawerclick" style="width:100%;max-width:0.38rem;" src="../../static/mobile/caidan.png" alt="">
              </a>
           </li>
            <li v-if="this.hidden" style="background: #00383F;border-bottom: 1px solid rgba(224, 255, 254, 0.5);height:0.99rem;z-index:999999999999">
              <a href="#" style="padding-top:0.34rem">
              <img  @click="clonclick" style="width:100%;max-width:0.38rem;" src="../../static/mobile/chahao.png" alt="">
              </a>
           </li>
           <li><router-link to="/customer"><img style="width:100%;max-width:0.41rem;" src="../../static/mobile/xinxi.png" alt=""></router-link></li>
           <li><router-link to="/" style="padding-top:0.24rem"><img style="width:100%;max-width:2.04rem;" src="../../static/mobile/logo1.png" alt=""></router-link></li>
           <li>
             <a @click="Searchdeldrawer"><img style="width:100%;max-width:0.31rem;" src="../../static/mobile/chaxun.png" alt=""></a>
               
            </li>
           <!-- <li>
              <router-link to="/Shopping" class="myshop">
                <img style="width:100%;max-width:0.33rem;" src="../../static/mobile/gouwudai.png" alt="">
                 <span class="cartCount" v-if="carCount !==0">
                <img src="../assets/shopicon.png" alt="">
                <i  style="color: #fff">{{ carCount }}</i>
              </span>
              </router-link>
            </li> -->
       </ul>
    </div>
    </div>
    <!-- 导航弹窗 -->
             <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :modal = 'false'
            size='4.1rem'
            :before-close="handleClose">
              <div class="mobnav">
                <ul>
                  <li v-for="(item, index) in homelist" :key="index" @click="skiptwohandle(item)">
                    <router-link :to="item.is_product == 1 ? {  name:'Product' ,query: {id: item.product_id}} : (item.is_product == 2 ? { name:'Product_List',query: {id: item.classify_id} }:{ name:item.route }) ">{{ item.route == 'Product_List' ? item.nav_name+'系列' : item.nav_name}}</router-link><span><img src="../../static/mobile/you.png" alt=""></span>
                  </li>
                </ul>
              </div>
            </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { logout_url,GetNavAPI,search_url ,homelist_url,GetphoneNavAPI } from "../request/api.js";
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: "Nav",
  components: {},
  directives: {},

  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      showbag: false,
      Searchdrawer:false,
      navlist:[],
      isshow:false,
      ismodal:false,
      show:true,
      input4:'',
      i:0,
      drawer: false,
       direction: 'ltr',
       directions:'ttb',
       block:true,
       hidden:false,
       homelist:[],
    };
  },
  computed: {
    ...mapState({
      carCount: (state) => state.carCount,
    }),
  },
  mounted() {
    this.getcarCount();
  
    GetNavAPI().then((res)=>{
      this.navlist = res.data.data
    })
    //   homelist_url().then((res)=>{
    //   this.homelist = res.data

    // })
    GetphoneNavAPI().then((res)=>{
      this.homelist = res.data.data
    })

  },
 watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id) {
        location.reload();
      }
    },
  },
  methods: {
    spArray(N,Q){
        var R=[],F;
        for(F=0;F<Q.length;){
            R.push(Q.slice(F,F += N))
        }
        return R;
    },
    skiptwohandle(item){
      console.log(item.is_product)
      if(item.is_product == 1){
        this.$router.push({path:'/Product',query:{id:item.product_id}})
      }if(item.is_product == 2){
        this.$router.push({path:'/Product_List',query:{id:item.classify_id}})
      }if(item.is_product == 3){
        this.$router.push({path:item.route})
      }
    },

    handleClose(done) {
          done();
         this.hidden = false
          this.block = true
      },
    Cancle(){
      this.Searchdrawer = false
      this.input4 = ''
    },
    Searchdeldrawer(){
      this.Searchdrawer = true
       this.drawer = false
       this.hidden = false
       this.block = true
    },
      validateCounts () {
         console.log(this.input4)
        this.drawer = false
        search_url({param:this.input4}).then((res)=>{
          if(res.data.data.tkey === 'product_classify_all'){
              this.$router.push({path:'/Product_List',query:{id:res.data.data.result}})
          }if(res.data.data.tkey === 'list'){
            if(res.data.data.result.length == 0){
              this.$message({
                message: '没有搜索的内容',
                type: 'warning'
              });
              this.input4 = ''
            }else{
              location.reload()
              let Product_List = res.data.data.result
              this.$router.push({path:'/Product_List'})
              this.$cookies.set('Product_List', JSON.stringify(Product_List))
            }
          } if(res.data.data.tkey === "problems"){
            this.$router.push({path:'/question'})
          }if(res.data.data.tkey ==='tkey'){
            this.$router.push({path:'/Information'})
          }if(res.data.data.tkey ==='home'){
            this.$router.data.push({path:'/'})
          }if(res.data.data.tkey === 'brand'){
            this.$router.push({path:'/Brand'})
          }if(res.data.data.tkey === 'news'){
            this.$router.push({path:'/Brand'})
          }
        })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    clonclick(){
       this.drawer = false
      if(this.drawer = false){
           this.block = true
            this.hidden=false
      }else{
            this.block = true
            this.hidden=false
      }
    },
    drawerclick(){
      this.drawer = true
      if(this.drawer = true){
           this.block = false
            this.hidden=true
      }else{
            this.block = true
            this.hidden=false
      }
    },
 

 changeValue1(callback,num){
   if( callback == true && num !=0){
     this.ismodal = true
   }else{
      this.ismodal = false
   }
 },
  
    // 获取登录状态和购物车数量
    getcarCount() {
      if (localStorage.getItem("userToken")) {
        let token = localStorage.getItem("userToken");
        this.$store.dispatch("setLogin", token);
        this.$store.dispatch("getCarCount");
      } else {
        localStorage.removeItem("userToken");
        this.$store.dispatch("setLogin", false);
        this.$store.dispatch("setCarCount", 0);
      }
    },
 
    tokenOverdue() {
      if (this.$cookies.isKey("tokenDate")) {
        let nowtime = new Date().getTime(),
          tokentime = this.$cookies.get("tokenDate");
        if (nowtime - tokentime >= 28740000) {
          //7小时59分过期
          localStorage.removeItem("userToken");
          this.$store.dispatch("setLogin", false);
          this.$store.dispatch("setCarCount", 0);
        } else {
          if (this.$store.state.isLogin) {
            //  获取并更新购物车数量
            this.$store.dispatch("getCarCount");
          } else {
            // console.log('请先登录');
          }
        }
      } else {
        localStorage.removeItem("userToken");
        this.$store.dispatch("setLogin", false);
        this.$store.dispatch("setCarCount", 0);
      }
    },
  },
  created() {
    this.tokenOverdue();
  },
};
</script>

<style lang="less" scoped> 
  .v-modal{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
}
      .menubox{
        width: 100%;
        overflow: hidden;
        color: #00383F;
        padding: 2% 0;
        border-bottom: 1px solid #F1D5AB;
        .menu_rig{
          float: left;
          width: 40%;
          font-weight: 500;
          text-align: center;
          .product_name{
            margin-top: 2%;
            margin-bottom: 1%;
          }
          img{
            width: 100%;
            max-width: 350px;
            border-radius: 10px;
          }
        }
        .menu_left{
          float: left;
          width: 48%;
           min-height: 250px;
           ul{
             display: block;
             display: inline-block;
             max-height: 230px;
            // writing-mode: vertical-lr;
            text-align: left;
            display: flex;
            flex-direction: column;
            // flex-wrap: wrap;
             li{
               display: inline-block;
              //  writing-mode: horizontal-tb;
               vertical-align: bottom;
               padding-bottom: .22rem;
              padding-right: .5rem;
              min-width: 100px;
              box-sizing: border-box;
               a{
                color: #00383F;
                font-size: 16px;
                display: inline-block;
               }
               a:hover{
                 border-bottom: 1px solid #00383F;
               }
              
             }
           }
          h6{
            font-size: 16px;
            font-family: Source Han Serif CN;
            font-weight: bold;
            padding-bottom: .5rem;
             text-align: left;
          }
        }
      }
.el-dropdown{
  height: 100%;
   color: #FCE199;
   font-family: "SimSun";
}

.active{
    color: #f1c582 !important;
  }
.Navcontainer {
  max-width: 1920px;
  z-index: 2003;
  position: fixed;
  height: 154px;
  margin: 0px auto;
  right: 0px;
  left: 0px;
  background: url("../../static/navbag.jpg")no-repeat;
  background-size: 100% 100%;
  .Nav {
    width: 80%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      margin: 0 auto;
      max-width: 1006px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
    .headleft {
      width: 52%;
      .logo1 {
          height: 152px;
      }
      h1:nth-child(2){
        margin-left: 10%;
      }
    h1{
      display: inline-block;
      vertical-align: middle;
       img{
         width: 100%;
       }
       
    }
    }
    .headrig {
      width: 40%;
      margin-left: 8%;
      ul {
        width: 100%;
        height: 148px;
        float: left;
        li {
          float: left;
          writing-mode: tb-rl;
          font-size: 0.18rem;
          padding-top: 10%;
          line-height: 100%;
          padding: 2.5% 5% 0 2%;
          height: 87%;
          text-align: initial;
           color: #FCCB99;
           text-shadow: 0 1px 0  #000b0b;
        span{
          margin-top: 6%;
          color: #FCCB99;
          u{
            text-decoration:none;
          }
        }
          a {
            display: inline-block;
            color: #FCCB99;
             font-size: 0.18rem;
          }
        }
      }
      
    }
    .shop {
      position: relative;
    }
    .carthide{
      display: inline-block!important;
    }
    .cartCount {
      display: none;
      position: absolute;
      top: 1%;
      right: -6px;
      img{
        width: 100%;
        position: relative;
      }
       i{
          position: absolute;
          writing-mode: horizontal-tb;
          top: 21%;
          left: 30%;
        }
    }
  }
}
.el-dropdown{
  font-size: 0.18rem;
}
.el-dropdown-menu{
  width: 100%!important;
  left: 50% !important;
  max-width: 1920px;
  transform: translateX(-50%)!important;
  background: url(../../static/navpro.jpg) no-repeat center center/100% 100%;
  padding: unset;
  /* left: 0!important; */
  border: unset!important;
}

.el-dropdown-menu.el-popper /deep/ .popper__arrow{
  border-bottom-color:unset!important;
}
@media screen and (min-width: 1920px){
  .el-dropdown-menu.el-popper /deep/ .popper__arrow{margin-left: calc(1920px - 100vw);}
}

.el-dropdown-menu.el-popper /deep/ .popper__arrow::after{
  width: 53px;
  height: 53px;
  background: url(../assets/prologo.png) no-repeat center center/100%;
  border: 0;
  left: 50%;
  top: 50%!important;
  transform: translate(-22%,-50%);
}
@media (max-width: 1228px) {
   .Navcontainer{
    .Nav{
      .headleft{
        width: 30%;
         .logo2{
          margin-left: 0!important;
          display: none!important;
        }
        h1{
          img{
            width: 100%;
            
          }
        }
       
      }
      .headrig{
        width: 49%;
      }
      .mobile{
        position: relative;
        .el-icon--right{
          color: #fff;
          position: absolute;
          top: 50%;
        }
      }
      /deep/.el-dropdown-menu el-popper{
        top: 10%!important;
      }
    } 
  } 
}
@media (max-width: 991px) {
/deep/.el-drawer__body{

background: url("../../static/mobile/mobnav.png")no-repeat;
background-size: 100% 100%;
}
/deep/.el-drawer__wrapper{
  top: 1rem;
}
  .phone{
    width: 100%;
    height: 1rem;
    background: url("../../static/mobile/navbg.png")no-repeat;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 777;
    .tabber{
    width: 100%;
    height: 1rem;
    position: relative;
      .Search{
      position: absolute;
      top: 0;
      right: 0;
      height: 0.9rem;
      background: #fff;
      z-index: 12;
      width: 6.5rem;
      /deep/.el-input-group__append{
        border-radius: unset;
      }
      /deep/.el-input__inner{
        height: 1rem;
        font-size: 0.24rem;
        border-radius: unset!important;
      }
      /deep/.el-icon-search{
        color: #00383F;
        font-size: 0.24rem;
      }
    /deep/.el-input__inner::placeholder{
      font-size: 0.24rem;
    }
    }
  ul{
    width: 100%;
    height: 1rem;
    display: flex;
    li{
        width: 14%;
        height:1rem;
        a{
          display: inline-block;
           padding-top: 0.33rem;
        }
          .myshop{
              position: relative;
                 .cartCount {
                  display: inline-block;
                  position: absolute;
                  left: 0.17rem;
                  top:0.2rem;
              img{
                width: 0.27rem;
                position: relative;
              }
              i{
                  position: absolute;
                 left: 0.07rem;
                  top: 0.03rem;
                  font-size: 0.18rem;
                }
            }
            }
        
    }
    :nth-child(3){
      width: 56%;
    }
  
   
  }
}
  }
  .mobnav{
    ul{
      width: 100%;
      text-align: left;
      li{
        width: 100%;
        height: 0.99rem;
        line-height: 0.99rem;
        border-bottom: 1px solid rgba(224, 255, 254, 0.5);
       
        span{
          float: right;
          margin-right: 0.5rem;
          img{
            width: 0.2rem;
            vertical-align: middle;
          }
        }
        a{
          color: #fff;
          font-size: 0.3rem;
           padding-left: 1rem;
        }
      }
    }
  }
  /deep/.el-drawer__header{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue